import React, { Component, useState } from "react";

const navItems = [
  { id: "home", href: "#home", title: "Home" },
  { id: "about", href: "#about", title: "About" },
  { id: "portfolio", href: "#portfolio", title: "Portfolio" },
  { id: "resume", href: "#resume", title: "Skills" },
  { id: "contact", href: "#footer", title: "Contact" },
];

const NavItem = ({ id, href, title, isSelected, onClick }) => {
  const handleClick = () => {
    onClick(id);
  };

  return (
    <li className={isSelected ? "current" : ""} onClick={handleClick}>
      <a className="smoothscroll" href={href}>
        {title}
      </a>
    </li>
  );
};

const Nav = () => {
  const [selectedItem, setSelectedItem] = useState("home");

  const handleClick = (id) => {
    setSelectedItem(id);
  };

  return (
    <nav id="nav-wrap">
      <a className="mobile-btn" href="#nav-wrap" title="Show navigation">
        Show navigation
      </a>
      <a className="mobile-btn" href="#hidenav" title="Hide navigation">
        Hide navigation
      </a>
      <ul id="nav" className="nav">
        {navItems.map((v) => (
          <NavItem
            key={v.id}
            id={v.id}
            isSelected={selectedItem === v.id}
            href={v.href}
            title={v.title}
            onClick={handleClick}
          />
        ))}
      </ul>
    </nav>
  );
};

export default class Header extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <React.Fragment>
        <header id="home">
          <Nav />

          <div className="row banner">
            <div className="banner-text">
              <h3
                style={{ color: "#F06000", fontFamily: "montserrat-regular" }}
              >
                HELLO, I AM
              </h3>
              <h1 className="responsive-headline">{resumeData.name}</h1>
              <h2
                style={{
                  color: "#F06000",
                  fontFamily: "montserrat-regular",
                  textTransform: "uppercase",
                }}
              >
                I am a {resumeData.role} from India
              </h2>
              <hr />
              <ul className="social">
                {resumeData.socialLinks &&
                  resumeData.socialLinks.map((item) => {
                    return (
                      <li key={item.name}>
                        <a href={item.url} target="_blank" rel="noreferrer noopener">
                          <i className={item.className} />
                        </a>
                      </li>
                    );
                  })}
              </ul>
            </div>
          </div>

          <p className="scrolldown">
            <a className="smoothscroll" href="#about">
              <i className="icon-down-circle" />
            </a>
          </p>
        </header>
      </React.Fragment>
    );
  }
}
